"use client";

import { HugeiconsIcon } from "@hugeicons/react";
import { Search01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Button } from "@workspace/frontend-ui";
import {
  EVENT_SEARCH_SURPRISE_ME,
  listenForSearchModalEvent,
  propagateSearchModalOpen,
  SearchWidget,
} from "@workspace/search-ui";
import { useRouter } from "next/navigation";
import type { FC } from "react";
import { useEffect } from "react";

type Props = {
  locale: string;
  brand: string;
  countryCode?: string;
  placeholder: string;
};

const Search: FC<Props> = ({ locale, brand, countryCode, placeholder }) => {
  const router = useRouter();
  useEffect(() => {
    const handleFunc = (event: Event | CustomEvent) => {
      switch (event.type) {
        case EVENT_SEARCH_SURPRISE_ME:
          if ((event as CustomEvent).detail?.href?.startsWith("/")) {
            router.push(
              brand === "sportsbet"
                ? `/casino${(event as CustomEvent).detail.href}`
                : (event as CustomEvent).detail.href,
            );
          }
          break;
        default:
      }
    };
    const mappedEvents = listenForSearchModalEvent(handleFunc);
    return () => {
      mappedEvents.forEach((eventName: string) => {
        window.removeEventListener(eventName, handleFunc);
      });
    };
  }, []);

  return (
    <>
      <Button
        variant="unstyled"
        size="xl"
        onClick={propagateSearchModalOpen}
        className="justify-start rounded-full border border-border bg-secondary hover:bg-border text-muted-foreground !pr-14 md:!h-10.5"
        data-testid="header-search-input"
      >
        <HugeiconsIcon icon={Search01Icon} className="size-[12px]" />
        <span className="text-base font-normal">{placeholder}</span>
      </Button>
      <SearchWidget locale={locale} brand={brand} countryCode={countryCode} />
    </>
  );
};

export default Search;
